<script lang="ts">
  import api from '../api/api'
  import {user} from '../stores/user'
  import {modal} from '../stores/modal'
  import {settings} from '../stores/settings'
  import {onMount} from 'svelte'
  import {preventDefault} from '../utils/event'

  onMount(() => {
    loadSdk()
  })

  const w = window as any

  function loadSdk() {
    if (!w.fbAsyncInit) {
      w.fbAsyncInit = function () {
        const FB = w.FB as any

        FB.init({
          appId: $settings.facebook_key,
          xfbml: true,
          version: 'v2.8'
        })

        FB.AppEvents.logPageView()
      }
    }

    if (document.getElementById('facebook-jssdk')) {
      return
    }

    const script = document.createElement('script')
    script.id = 'facebook-jssdk'
    script.src = '//connect.facebook.net/en_US/sdk.js'
    document.head.appendChild(script)
  }

  function facebookLogin() {
    const FB = w.FB as any
    FB.login((response: any) => {
      if (response.authResponse) {
        FB.api('/me?fields=id,email,first_name,last_name,picture,birthday,website', (response: any) => {
          onLogInRequested(response)
        })
      }
    }, {scope: 'email,public_profile', return_scopes: true})
  }

  async function onLogInRequested(response: any) {
    response.provider = 'facebook'
    response.picture = response.picture.data.url
    response.url = response.website || `https://facebook.com/${response.id}`

    $user = await api.post('/authenticate/facebook', {user: response})
    modal.close()
  }
</script>

<button class={$$props.class ?? ''} onclick={preventDefault(facebookLogin)} disabled={$$props.disabled}>
  <slot />
</button>
